import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import BForm from 'JS/components/blain-form/BForm.vue';
import bugsnagClient from 'JS/global/bugsnag';
import CreatePasswordField from './CreatePasswordField.vue';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import ExternalAuthLogin from './ExternalAuthLogin.vue';
import HorizontalTextDivider from 'JS/components/HorizontalTextDivider.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { BCheckbox, BSubmitButton, BTextField } from "Src/js/components/blain-form";
import { nextTick, onMounted, ref } from 'vue';
import { ICreateAccountResource, ICreateAccountResponse, LoginPageType } from 'JS/types/Account';
import { useServices } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAccountPage',
  props: {
    skipCartMerge: { type: Boolean },
    antiForgeryToken: null
  },
  emits: ["change-page", "loading", "go-to-rewards", "signed-in"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'change-page', page: LoginPageType): void;
	(event: 'loading', value: boolean): void;
	(event: 'go-to-rewards'): void;
	(event: 'signed-in', isRewardsMember: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	skipCartMerge: boolean,
	antiForgeryToken: string,
}





const { accountService } = useServices();

const createAccountData = ref<ICreateAccountResource>({
	firstName: '',
	lastName: '',
	emailAddress: '',
	password: '',
	saveLogin: true,
});

const errorMessage = ref<string>("");
const headerFocuser = ref<HTMLElement | null>(null);

async function handleCreateAccount() {
	try {
		emit('loading', true);
		const results: ICreateAccountResponse = await accountService.createAccount(createAccountData.value, props.antiForgeryToken);
		if (!results?.success) {
			errorMessage.value = "Unable to create account";
			emit('loading', false);
		} else {
			window.blainGtmDataLayer.push({
				'event': "create_login"
			});
			if (results.headerJson && window.vueEventBus) {
				window.vueEventBus.$emit('header-vm', results.headerJson);
			}
			emit('go-to-rewards');
		}
	} catch (err) {
		errorMessage.value = "<span class='bold'>Something went wrong.</span> Please try again later.";
		emit('loading', false);
		bugsnagClient.notify(err);
	}
}

onMounted(() => {
	nextTick(()=> headerFocuser.value?.focus());
});


return { __sfc: true,props, emit, accountService, createAccountData, errorMessage, headerFocuser, handleCreateAccount, validation, BForm, CreatePasswordField, ErrorBanner, ExternalAuthLogin, HorizontalTextDivider, LinkButton, BCheckbox, BSubmitButton, BTextField }
}

})